import { createStore } from "./create-store";

//
// State
//
export interface AuthState {
  token: string | null;
  userId?: number | null;
}

export interface AuthActions {
  startSession: (token: string) => void;
  stopSession: () => void;
  setUserId: (id: number | null) => void;
}

const defaultInitialState: AuthState = {
  token: null,
};

export function createAuthStore(
  name: string = "auth",
  initialState: AuthState = defaultInitialState
) {
  const store = createStore<AuthState>(name, initialState, {
    persist: ["token"],
  });

  const actions: AuthActions = {
    startSession(token: string) {
      store.setState((state) => {
        return {
          ...state,
          token,
        };
      });
    },

    stopSession() {
      store.setState((state) => {
        return {
          ...state,
          token: null,
        };
      });
    },

    setUserId(id: number | null) {
      store.setState((state) => {
        return {
          ...state,
          userId: id,
        };
      });
    },
  };

  return [store, actions] as [typeof store, AuthActions];
}
